import { Type } from '@angular/core';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';

import * as FormActions from './form.actions';

export interface FormState {
  component: Type<any>;
  data: {
    header?: string;
    panelClass?: string;
    closeWithoutAdditionalModal?: boolean;
  };
}

export const initialState: FormState = {
  component: undefined,
  data: {
    closeWithoutAdditionalModal: false,
  },
};

const reducer = createReducer(
  initialState,
  on(FormActions.formOpen, (state, { formState }) => ({ ...formState })),
);

export function formReducer(state: FormState | undefined, action: Action) {
  return reducer(state, action);
}

export const getFormState = createFeatureSelector<FormState>('form');
